/*
 * Laeg i kurv fra produktkortet paa webshoppens kategorisider.
 *
 * Elementet goer kun én ting: finder ud af HVILKEN variant der skal i kurven.
 * Selve tilfoejelsen sker i temaets <product-form> (assets/product-form.js),
 * som ogsaa aabner cart-notification bagefter. Der er bevidst ingen anden
 * kurv-logik her.
 *
 * Vigtigt: connectedCallback, ikke constructor. facets.js udskifter hele
 * #ProductGridContainer.innerHTML ved hver filtrering, saa kortene bliver
 * bygget forfra. Nye elementer opgraderes af sig selv, men bindingen skal taale
 * at koere igen paa det samme element, hvis det flyttes rundt i DOM'en.
 */
if (!customElements.get('card-add-to-cart')) {
  customElements.define(
    'card-add-to-cart',
    class CardAddToCart extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        const toggle = event.target.closest('.card-add__toggle');
        if (toggle) return this.openSizes(toggle);

        const size = event.target.closest('.card-add__size');
        if (size) return this.chooseSize(size);

        const submit = event.target.closest('.card-add__submit');
        if (submit) this.sendTracking(submit, this.chosenVariantTitle);
      }

      openSizes(toggle) {
        const sizes = this.querySelector('.card-add__sizes');
        if (!sizes) return;
        toggle.hidden = true;
        toggle.setAttribute('aria-expanded', 'true');
        sizes.hidden = false;
        const first = sizes.querySelector('.card-add__size:not([disabled])');
        if (first) first.focus();
      }

      chooseSize(button) {
        if (button.hasAttribute('disabled')) return;

        const form = this.querySelector('form');
        const input = this.querySelector('input[name="id"]');
        const submit = this.querySelector('.card-add__submit');
        if (!form || !input || !submit) return;

        // product-form.js slaar feltet til i sin constructor, men naar vi
        // submitter programmatisk, kan vi ikke vide om den er naaet det.
        input.disabled = false;
        input.value = button.dataset.variantId;

        this.chosenVariantTitle = button.dataset.variantTitle || button.textContent.trim();

        // Stoerrelsesraekken erstattes af koeb-knappen, saa spinneren og en
        // eventuel fejlbesked staar der, hvor kunden lige klikkede.
        const label = submit.querySelector('.card-add__label');
        if (label && this.chosenVariantTitle) {
          if (!label.dataset.base) label.dataset.base = label.textContent.trim();
          label.textContent = `${label.dataset.base} ${this.chosenVariantTitle}`;
        }
        this.querySelector('.card-add__sizes').hidden = true;
        submit.hidden = false;

        this.sendTracking(submit, this.chosenVariantTitle);

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(submit);
        } else {
          submit.click();
        }
      }

      /*
       * Samme dataLayer-haendelse som produktsiden sender fra
       * snippets/tracking.liquid. Uden den ville et koeb startet fra
       * kategorisiden mangle helt i GA4.
       */
      sendTracking(button, variantTitle) {
        if (!button.dataset.productId) return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            items: [
              {
                item_id: button.dataset.productId,
                item_name: button.dataset.productTitle,
                item_brand: button.dataset.productVendor,
                item_variant: variantTitle || '',
                currency: button.dataset.currency,
                price: button.dataset.productPrice,
              },
            ],
          },
        });
      }
    }
  );
}
